<template>
    <form :action="`/settings/children/${ child.id }`" method="post" enctype="multipart/form-data" @submit="loading = true">
        <csrf></csrf>
        <input type="hidden" name="_method" value="PUT">
        <div class="input-container">
            <div class="input-title">First Name</div>
            <div class="input-box"><input type="text" name="first_name" v-model="form.first_name"></div>
        </div>
        <div class="input-container">
            <div class="input-title">Last Name</div>
            <div class="input-box"><input type="text" name="last_name" v-model="form.last_name"></div>
        </div>
        <photo-upload name="avatar" :current-photo="child.currentImage" title="Profile Photo" preview-title="Photo To Upload" :photo-key="{ type: 'child', id: child.id }"></photo-upload>
        <div class="input-container">
            <div class="input-title">Birthdate</div>
            <div class="input-box">
                <date-picker name="birthdate" v-model="form.birthdate" format="F j, Y" placeholder="Select Birthdate"></date-picker>
            </div>
        </div>
        <button v-if="!loading" type="submit" class="submit-standard good-bg">Update Child<span class="fa fa-plus"></span></button>
        <button v-if="loading" type="submit" class="submit-standard neutral-bg" disabled>Processing...</button>
    </form>
</template>

<script>

import moment from 'moment';

export default {

    props: [ 'child', 'old' ],

    data() {
        const form = Object.assign(this.child, this.old);
        form.birthdate = moment(form.birthdate);
        if (form.birthdate.isValid()) {
            form.birthdate = form.birthdate.format('MMMM D, YYYY');
        }

        return {
            loading: false,
            form,
        };
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/settings/children/EditChild.vue